var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      staticClass: "basic-modal math-editor-modal",
      attrs: {
        id: _vm.id,
        title: _vm.$t("common.modal.math_editor.title"),
        "ok-title": _vm.$t("common.confirm"),
        "close-title": _vm.$t("common.cancel")
      },
      on: { ok: _vm.addMath, cancel: _vm.clear }
    },
    [
      _c("nav", { staticClass: "navbar navbar-toggleable navbar-light" }, [
        _c("ul", { staticClass: "nav navbar-nav" }, [
          _c(
            "li",
            {
              staticClass: "nav-item",
              class: { active: _vm.currentTab === "basic" }
            },
            [
              _c(
                "a",
                {
                  staticClass: "nav-link typography--body-3",
                  on: {
                    click: function($event) {
                      _vm.currentTab = "basic"
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("common.modal.math_editor.tabs.basic")) +
                      "\n        "
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "nav-item",
              class: { active: _vm.currentTab === "geometry" }
            },
            [
              _c(
                "a",
                {
                  staticClass: "nav-link typography--body-3",
                  on: {
                    click: function($event) {
                      _vm.currentTab = "geometry"
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("common.modal.math_editor.tabs.geometry")) +
                      "\n        "
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "nav-item",
              class: { active: _vm.currentTab === "etc" }
            },
            [
              _c(
                "a",
                {
                  staticClass: "nav-link typography--body-3",
                  on: {
                    click: function($event) {
                      _vm.currentTab = "etc"
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("common.modal.math_editor.tabs.etc")) +
                      "\n        "
                  )
                ]
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "width-100" }, [
          _c(
            "table",
            { staticClass: "table table-responsive math-cmd-table width-100" },
            [
              _c(
                "tbody",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab === "basic",
                      expression: "currentTab === 'basic'"
                    }
                  ]
                },
                [
                  _c("tr", [
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Exponent",
                            "aria-label": "Exponent"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("^", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("x^{}")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Square root",
                            "aria-label": "Square root"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\sqrt", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\sqrt{}")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Square brackets",
                            "aria-label": "Square brackets"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("[", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\left[\\right]")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Divide", "aria-label": "Divide" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\div", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\div")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Minus", "aria-label": "Minus" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("-", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("-")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Equal to",
                            "aria-label": "Equal to"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("=", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("=")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Less than",
                            "aria-label": "Less than"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\lt")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\lt")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Greater than",
                            "aria-label": "Greater than"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\gt")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\gt")]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Subscript",
                            "aria-label": "Subscript"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("_", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("x_{}")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Root", "aria-label": "Root" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\sqrt[]{}")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\sqrt[]{}")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Parentheses",
                            "aria-label": "Parentheses"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("(", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\left(\\right)")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Times", "aria-label": "Times" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\times", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\times")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Plus", "aria-label": "Plus" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("+", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("+")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Not equal to",
                            "aria-label": "Not equal to"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\neq")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\neq")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Less than or equal to",
                            "aria-label": "Less than or equal to"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\leq")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\leq")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Greater than or equal to",
                            "aria-label": "Greater than or equal to"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\geq")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\geq")]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Fraction",
                            "aria-label": "Fraction"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\frac", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\frac{}{}")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", {
                      staticClass: "math-cmd-btn-box border-right empty-box"
                    }),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Curly brackets",
                            "aria-label": "Curly brackets"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("{", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\left\\{\\right\\}")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box empty-box" }),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Plus minus",
                            "aria-label": "Plus minus"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\pm", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\pm")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Approximately equal to",
                            "aria-label": "Approximately equal to"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\approx")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\approx")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Right arrow",
                            "aria-label": "Right arrow"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\to")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\to")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Triple bar",
                            "aria-label": "Triple bar"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\equiv")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\equiv")]
                          )
                        ]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "tbody",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab === "geometry",
                      expression: "currentTab === 'geometry'"
                    }
                  ]
                },
                [
                  _c("tr", [
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Angle", "aria-label": "Angle" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\angle", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\angle")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Is perpendicular to",
                            "aria-label": "Is perpendicular to"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\perp", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\perp")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Segment", "aria-label": "Segment" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\overline", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\overline{xyz}")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Over right arrow",
                            "aria-label": "Over right arrow"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\overrightarrow", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\overrightarrow{xyz}")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Slash", "aria-label": "Slash" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\slash", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\slash")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Triangle",
                            "aria-label": "Triangle"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\triangle", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\triangle")]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Measured angle",
                            "aria-label": "Measured angle"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\measuredangle", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\measuredangle")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Degree", "aria-label": "Degree" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("^{\\circ}")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("^{\\circ}")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Over arc",
                            "aria-label": "Over arc"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\overarc", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\overarc{xyz}")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Text", "aria-label": "Text" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\textrm", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\textrm{AB}")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Square", "aria-label": "Square" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\square", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\square")]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Distance",
                            "aria-label": "Distance"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("|", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\left| \\right|")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Similarity",
                            "aria-label": "Similarity"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\sim", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\sim")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Over left right arrow",
                            "aria-label": "Over left right arrow"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd(
                                "\\overleftrightarrow",
                                true
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\overleftrightarrow{xyz}")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Pi", "aria-label": "Pi" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\pi", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\pi")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Big circle",
                            "aria-label": "Big circle"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\bigcirc", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\bigcirc")]
                          )
                        ]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "tbody",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab === "etc",
                      expression: "currentTab === 'etc'"
                    }
                  ]
                },
                [
                  _c("tr", [
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Infinity",
                            "aria-label": "Infinity"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\infty", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\infty")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Therefore",
                            "aria-label": "Therefore"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\therefore", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\therefore")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Sine", "aria-label": "Sine" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\sin", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\sin")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Natural log",
                            "aria-label": "Natural log"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\ln", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\ln")]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", {
                      staticClass: "math-cmd-btn-box border-right empty-box"
                    }),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Because", "aria-label": "Because" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\because")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\because")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Cosine", "aria-label": "Cosine" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\cos", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\cos")]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", {
                      staticClass: "math-cmd-btn-box border-right empty-box"
                    }),
                    _vm._v(" "),
                    _c("td", {
                      staticClass: "math-cmd-btn-box border-right empty-box"
                    }),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Tangent", "aria-label": "Tangent" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\tan", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\tan")]
                          )
                        ]
                      )
                    ])
                  ])
                ]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "math-editor-field-container" }, [
          _c("span", { staticClass: "math-editor-field" })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71e49b16", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71e49b16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/my-cards/components/MathEditorModal.vue
// module id = EsBt
// module chunks = 1